<template>
    <div class="collect-form">
        <el-divider content-position="left">
            <h3>竞赛:</h3>
        </el-divider>
        <div class="header-button mb-1">
            <el-button v-if="!isOnlyRead" :disabled="isEditing" @click="showEdit()" type="primary" size="small">
                新增竞赛
            </el-button>
        </div>
        <table-view :total="total" :query-info.sync="queryInfo" @reload-table="renderTable">
            <el-table :data="tableData" class=" mt-1" style="width: 100%" border stripe>
                <el-table-column type='index' label='ID' width='50' />
                <el-table-column prop="gradeName" min-width="100" label="学年"></el-table-column>
                <el-table-column prop="term" label="学期">
                    <template v-slot="{ row }">
                        {{ row.term ? `第${row.term}学期` : '' }}
                    </template>
                </el-table-column>
                <el-table-column prop="contestantType" min-width="100" label="参赛人类别"></el-table-column>
                <el-table-column prop="studentName" label="学生姓名"></el-table-column>
                <el-table-column prop="contestName" label="竞赛名"></el-table-column>
                <el-table-column prop="contestCategory" label="竞赛类别"></el-table-column>
                <el-table-column prop="awardCategory" label="获奖类别"></el-table-column>
                <el-table-column label="操作" min-width="150" fixed="right">
                    <template v-slot="{ row }">
                        <div v-if="!isOnlyRead">
                            <el-button type="text" :disabled="isEditing" @click="showEdit(row.id)">
                                编辑
                            </el-button>
                            <el-button type="text" :disabled="isEditing"
                                @click="del(delCompetitionApi, row.id, `竞赛-${row.contestName}`)">
                                删除
                            </el-button>
                        </div>
                        <div v-else>
                            <el-button type="text" @click="showEdit(row.id)">
                                查看详情
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </table-view>
        <el-divider v-if="isEditing" content-position="left">
            <h3>{{ isOnlyRead ? '竞赛详情' : '新增/编辑竞赛:' }}</h3>
        </el-divider>
        <div v-if="isEditing" class="header-button mb-1">
            <el-button v-if="!isOnlyRead" @click="save" type="primary" size="small">
                保存竞赛
            </el-button>
            <el-button v-if="!isOnlyRead" @click="closeEdit()" type="danger" size="small">
                取消新增/编辑
            </el-button>
        </div>
        <el-form v-if="isEditing" ref='form' :model='formData' :rules='rules' label-width='170px'>
            <el-row>
                <el-col :span='12'>
                    <el-form-item label='参赛人类别' prop='contestantType'>
                        <el-radio-group @change="contestantTypeChange" v-if="!isOnlyRead" v-model="formData.contestantType">
                            <el-radio-button v-for="{ type } in contestantTypeList" :key="type" :label="type">{{ type
                            }}</el-radio-button>
                        </el-radio-group>
                        <div v-else>{{ formData.contestantType }}</div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span='12'>
                    <el-form-item label='学生姓名' prop='studentName'>
                        <tool-tips-group tips-content="若有多个学生，请用中文逗号‘，’间隔">
                            <el-input :disabled="formData.contestantType === '教师' || isOnlyRead"
                                v-model.trim='formData.studentName' />
                        </tool-tips-group>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span='12'>
                    <el-form-item label='竞赛名' prop='contestName'>
                        <el-input :disabled="isOnlyRead" v-model.trim='formData.contestName' />
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item label='竞赛类别' prop='contestCategory'>
                        <el-select :disabled="isOnlyRead" v-model="formData.contestCategory" placeholder="请选择">
                            <el-option v-for=" item in contestCategoryList" :key="item.type" :label="item.type"
                                :value="item.type">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item label='获奖类别' prop='awardCategory'>
                        <el-select :disabled="isOnlyRead" v-model="formData.awardCategory" placeholder="请选择">
                            <el-option v-for=" item in awardCategoryList" :key="item.type" :label="item.type"
                                :value="item.type">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div class="footer">
            <!-- <cancel-popover ref="cancelRef" :disabled.sync="loadData.loading" :update-flag="updateFlag" />
            <el-button type='primary' @click="save('教学信息-竞赛', save())">确 定</el-button> -->
        </div>
    </div>
</template>

<script>
import dialog from '@/vue/mixins/dialog'
import tableView from '@/vue/mixins/table-view'
import { cloneDeep, isEqual } from 'lodash'

import { contestCategoryList, awardCategoryList, contestantTypeList } from './options.js'

import { saveCompetitionApi, getCompetitionByIdApi, pageCompetitionApi, delCompetitionApi } from '@/api/achievement/competition-api.js'
import toolTipsGroup from '../../../../../../components/common/components/toolTipsGroup.vue'

export default {
    components: { toolTipsGroup },
    name: 'gradeDialog',
    mixins: [dialog, tableView],
    props: {
        term: String,
        gradeName: String,
        isOnlyRead: Boolean,
        CurUserId: String
    },
    data() {
        return {
            id: '',
            isEditing: false,
            gradeList: {},
            termList: {},
            contestCategoryList,
            awardCategoryList,
            contestantTypeList,
            formData: {
                id: '',
                userId: '',
                realName: '',
                deptName: '',
                teacherNo: '',
                gradeName: '',
                term: '',
                contestantType: '学生',
                studentName: '',
                contestName: '',
                contestCategory: '',
                awardCategory: ''
            },
            formDataClone: {},
            tableData: [],
            rules: {
                contestCategory: [{ required: true, message: '请选择竞赛类别', trigger: 'change' }],
                contestantType: [{ required: true, message: '请选择参赛人类别', trigger: 'change' }],
                awardCategory: [{ required: true, message: '请选择获奖类别', trigger: 'change' }],
                contestName: [{ required: true, message: '请填写竞赛名', trigger: 'change' }],
                studentName: [{ required: true, message: '请填写学生姓名', trigger: 'change' }]
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.renderTable()
        })
        this.formDataClone = cloneDeep(this.formData)
    },
    methods: {
        delCompetitionApi,
        renderTable() {
            this.queryInfo.term = this.term
            this.queryInfo.gradeName = this.gradeName

            if (this.isOnlyRead === true) {
                this.queryInfo.userId = this.CurUserId
            } else {
                this.queryInfo.userId = this.$store.state.login.userInfo.id
            }

            pageCompetitionApi(this.queryInfo).then((res) => {
                this.tableData = res.data.list
                this.total = res.data.total
            })
        },
        // 参赛人类别改变
        contestantTypeChange(e) {
            if (e === '学生') {
                this.rules.studentName = [{ required: true, message: '请填写学生姓名', trigger: 'change' }]
            } else {
                this.rules.studentName = []
            }
            this.$refs.form.clearValidate()

        },
        showEdit(id) {
            this.isEditing = true

            if (id) {
                this.getDataById(id, getCompetitionByIdApi)
            } else {
                this.setInitData()
            }
        },
        closeEdit() {
            this.isEditing = false
            this.clear()
        },
        save() {
            if (isEqual(this.formData, this.formDataClone)) {
                this.$message.error({ message: '表单内容没有改变，请填写表单!' })
                return
            }
            this.formData.term = this.term
            this.formData.gradeName = this.gradeName

            this.$refs.form.validate((valid) => {
                if (valid) {
                    saveCompetitionApi(this.formData).then(() => {
                        this.renderTable()
                        this.isEditing = false
                        this.clear()
                    })
                }
            })
        },
        clear() {
            Object.keys(this.formData).map(item => {
                this.formData[item] = ''
            })
            this.setInitData()
        }
    }
}
</script>
<style lang="scss" scoped>
.footer {
    display: flex;
    justify-content: flex-end;
    margin: 20px 0;
}
</style>
